import React from "react";
import { Container, Grid, Typography, Paper } from "@mui/material";
import Youtube from "../images/yt.png";
import Tweet from "../images/tweet.png";
import Linkedin from "../images/Linkedin.png";
import Instagram from "../images/Insta.png";
import Facebook from "../images/facebook.png";
import Web from "../images/Web.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import "./Home.css"; // Import CSS file

const Contact = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 7 }}>
      <Grid container spacing={4}>
        {/* US Location */}
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11718.825499118026!2d-74.47007400948104!3d40.285687823249745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3d972ac84d797%3A0x71efabdc30575134!2s7%20Preservation%20Dr%2C%20Monroe%20Township%2C%20NJ%2008831%2C%20USA!5e0!3m2!1sen!2sin!4v1736406425862!5m2!1sen!2sin"
              width="100%"
              height="300px"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="US Location"
            ></iframe>
            <Typography variant="h6" sx={{ mt: 2 }}>
              <FontAwesomeIcon icon={faMapMarkerAlt} color="blue" /> US Location
            </Typography>
            <Typography>
              <strong>New Jersey:</strong>
              <br /> 7 Preservation Dr, Monroe NJ, 08902, USA
              <br /> <br />
            </Typography>
            <Typography sx={{ mt: 1 }}>
              <FontAwesomeIcon icon={faPhone} color="blue" /> 732-915-3055
            </Typography>
          </Paper>
        </Grid>

        {/* India Location */}
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.5799308920414!2d75.92801897463306!3d17.670043694601972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5db0a1188be13%3A0x1c3c72af1dcdea02!2sSST%20India!5e0!3m2!1sen!2sin!4v1718100124631!5m2!1sen!2sin"
              width="100%"
              height="300px"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="India Location"
            ></iframe>
            <Typography variant="h6" sx={{ mt: 2 }}>
              <FontAwesomeIcon icon={faMapMarkerAlt} color="blue" /> India
              Location
            </Typography>
            <Typography>
              <strong>Solapur:</strong>
              <br /> Plot No.C-29 Naganath Laghu Udyog, Akkalkot Road MIDC,
              Solapur, Maharashtra-413006
            </Typography>
            <Typography sx={{ mt: 1 }}>
              <FontAwesomeIcon icon={faPhone} color="blue" /> +91 9370588999 /{" "}
              +91 7058478425
            </Typography>
          </Paper>
        </Grid>

        {/* Social Media Links */}
        {/* <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6">Follow Us</Typography>
            <Typography>
              <img src={Web} alt="Website" className="cu_img" /> Website:{" "}
              <a
                href="http://sstus.net/"
                target="_blank"
                rel="noopener noreferrer"
              >
                http://sstus.net/
              </a>
            </Typography>
            <Typography>
              <img src={Facebook} alt="Facebook" className="cu_img" /> Facebook:{" "}
              <a
                href="https://www.facebook.com/shri.saitech/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook Page
              </a>
            </Typography>
            <Typography>
              <img src={Instagram} alt="Instagram" className="cu_img" />{" "}
              Instagram:{" "}
              <a
                href="https://instagram.com/shri_saitech?igshid=10ur0rtbu09ay"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram Profile
              </a>
            </Typography>
          </Paper>
        </Grid> 

        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6">More Social Media</Typography>
            <Typography>
              <img src={Linkedin} alt="LinkedIn" className="cu_img" /> LinkedIn:{" "}
              <a
                href="https://www.linkedin.com/company/sstllc/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn Profile
              </a>
            </Typography>
            <Typography>
              <img src={Tweet} alt="Twitter" className="cu_img" /> Twitter:{" "}
              <a
                href="https://twitter.com/ShriSaiTech1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter Profile
              </a>
            </Typography>
            <Typography>
              <img src={Youtube} alt="YouTube" className="cu_img" /> YouTube:{" "}
              <a
                href="https://myaccount.google.com/u/0/"
                target="_blank"
                rel="noopener noreferrer"
              >
                YouTube Channel
              </a>
            </Typography>
          </Paper>
        </Grid>*/}
      </Grid>
    </Container>
  );
};

export default Contact;
